import Controller from '@ember/controller';
import {
  type MailchimpFundSyncInfo,
  MailchimpSyncRouteModel,
} from 'donor-elf-web/routes/funds/fund/more/mailchimp-sync';
import { service } from '@ember/service';
import CurrentUser from 'donor-elf-web/services/current-user';
import { action } from '@ember/object';
import { tracked } from '@glimmer/tracking';
import Store from '@ember-data/store';
import FundsService from 'donor-elf-web/services/funds-service';

export default class MailchimpConnectedController extends Controller {
  @service declare currentUser: CurrentUser;
  @service declare fundsService: FundsService;
  @service declare store: Store;

  model!: MailchimpSyncRouteModel;
  @tracked editFundSyncInfo?: MailchimpFundSyncInfo;

  get noFundsAreSynced() {
    return this.model.mailchimpFundSyncInfos.length === 0;
  }

  @action
  addSync() {
    this.editSync();
  }

  @action
  editSync(fundSyncInfo?: MailchimpFundSyncInfo) {
    if (fundSyncInfo) {
      this.editFundSyncInfo = fundSyncInfo;
    } else {
      let mailchimpFundSync = this.store.createRecord('mailchimp-fund-sync');
      let fund = this.fundsService.selectedFund!;
      mailchimpFundSync.fundId = fund.id;

      let mailchimpAccount = undefined;
      let mailchimpAudience = undefined;
      if (this.model.mailchimpAccounts.length === 1) {
        mailchimpAccount = this.model.mailchimpAccounts[0];
        mailchimpFundSync.mailchimpAccountId = mailchimpAccount.id;
        if (this.model.mailchimpAccounts[0].audiences.length === 1) {
          mailchimpAudience = this.model.mailchimpAccounts[0].audiences[0];
          mailchimpFundSync.audienceId = mailchimpAudience.id;
        }
      }

      this.editFundSyncInfo = {
        mailchimpFundSync,
        fund,
        mailchimpAudience,
        mailchimpAccount,
      };
    }
  }

  @action
  handleSyncSaved(fundSyncInfo: MailchimpFundSyncInfo) {
    if (
      !this.model.mailchimpFundSyncInfos.some(
        (x) => x.mailchimpFundSync.id === fundSyncInfo.mailchimpFundSync.id,
      )
    ) {
      this.model.mailchimpFundSyncInfos = [
        ...this.model.mailchimpFundSyncInfos,
        fundSyncInfo,
      ];
    }
    this.editFundSyncInfo = undefined;
  }

  @action
  handleSyncDeleted(fundSyncInfo: MailchimpFundSyncInfo) {
    this.model.mailchimpFundSyncInfos =
      this.model.mailchimpFundSyncInfos.filter(
        (x) => x.mailchimpFundSync.id !== fundSyncInfo.mailchimpFundSync.id,
      );
  }

  @action
  handleCancelEditSync() {
    this.editFundSyncInfo = undefined;
  }
}
